module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-form', {
    ref: "queryForm",
    attrs: {
      "size": "mini",
      "inline": true,
      "label-position": "left",
      "model": _vm.queryForm
    }
  }, [(_vm.shops.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "店铺名称",
      "prop": "shopId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "remote-method": _vm.remoteShopMethod,
      "placeholder": "请输入店铺"
    },
    model: {
      value: (_vm.queryForm.shopId),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "shopId", $$v)
      },
      expression: "queryForm.shopId"
    }
  }, _vm._l((_vm.shopList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "交易时间:",
      "prop": "date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "size": "small",
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "placeholder": "请选择日期"
    },
    model: {
      value: (_vm.queryForm.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "dateRange", $$v)
      },
      expression: "queryForm.dateRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "交易类型:",
      "prop": "type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryForm.type),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "type", $$v)
      },
      expression: "queryForm.type"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "0",
      "label": "全部"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "1",
      "label": "校园卡"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "2",
      "label": "非校园卡"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.fetchData
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('queryForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-row', {
    staticClass: "pb10"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.printPDF
    }
  }, [_vm._v("打印")])], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card mb20",
    staticStyle: {
      "background-color": "#eaf5fc"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('p', [_vm._v("销售订单总计")]), _vm._v(" "), _c('p', {
    staticClass: "red mt10"
  }, [_vm._v(_vm._s(_vm.summary.orderCount) + "单")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('p', [_vm._v("销售订单金额总计")]), _vm._v(" "), _c('p', {
    staticClass: "red mt10"
  }, [_vm._v(_vm._s(_vm.summary.orderAmount) + "元")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('p', [_vm._v("退款订单总计")]), _vm._v(" "), _c('p', {
    staticClass: "red mt10"
  }, [_vm._v(_vm._s(_vm.summary.refundCount) + "单")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('p', [_vm._v("退款金额总计")]), _vm._v(" "), _c('p', {
    staticClass: "red mt10"
  }, [_vm._v(_vm._s(_vm.summary.refundAmount) + "元")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('p', [_vm._v("商户结算款总计")]), _vm._v(" "), _c('p', {
    staticClass: "red mt10"
  }, [_vm._v(_vm._s(_vm.summary.sealAmount) + "元")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('p', [_vm._v("订单营业款总计")]), _vm._v(" "), _c('p', {
    staticClass: "red mt10"
  }, [_vm._v(_vm._s(_vm.summary.incomeAmount) + "元")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('p', [_vm._v("搭伙费总计")]), _vm._v(" "), _c('p', {
    staticClass: "red mt10"
  }, [_vm._v(_vm._s(_vm.summary.extraAmount) + "元")])])], 1)], 1), _vm._v(" "), _c('export-excel', {
    staticClass: "fl",
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "params": _vm.exportParams,
      "action": _vm.$apiUrl.checkBillTotalSchool,
      "target": 'oc',
      "field": _vm.field,
      "filename": _vm.filename,
      "fieldname": _vm.fieldName
    }
  }), _vm._v(" "), _c('el-popover', {
    staticStyle: {
      "float": "left",
      "margin-bottom": "20px"
    },
    attrs: {
      "placement": "right",
      "width": "560",
      "trigger": "click"
    }
  }, [_c('div', [_c('p', {
    staticClass: "mb20 mt10"
  }, [_vm._v("1、销售订单金额-退款订单金额=订单营业款=商户结算款+服务费（佣金）+加价配送费+搭伙费")]), _vm._v(" "), _c('p', {
    staticClass: "mb20"
  }, [_vm._v("2、日结非校园卡结算金额=商户结算款+搭伙费（公司付学校）")]), _vm._v(" "), _c('p', {
    staticClass: "mb20"
  }, [_vm._v("3、月结校园卡结算金额=服务费（佣金）+加价配送费（学校付公司）")])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "reference",
      "size": "mini",
      "type": "primary"
    },
    slot: "reference"
  }, [_vm._v("财务公式")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "时间",
      "width": "140",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "schoolName",
      "label": "学校名称",
      "width": "150",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "shopName",
      "label": "店铺名称",
      "width": "120",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "交易类型",
      "width": "80",
      "show-overflow-tooltip": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 1) ? _c('span', [_vm._v("校园卡")]) : (scope.row.type == 2) ? _c('span', [_vm._v("非校园卡")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderNum",
      "label": "销售订单笔数",
      "width": "100",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderAmount",
      "label": "营业金额（含退款）",
      "width": "100",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "refundOrderNum",
      "label": "退款订单笔数",
      "width": "100",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "refundOrderAmount",
      "label": "退款订单营业款",
      "width": "100",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "incomeAmount",
      "width": "100",
      "label": "营业金额",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "commercialAmount",
      "width": "100",
      "label": "商户结算款",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "settleAmount",
      "width": "100",
      "label": "商户结算款（含退款）",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "refundSettleAmount",
      "width": "100",
      "label": "退款订单结算款",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "commission",
      "label": "服务费",
      "width": "80",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "alyIncome",
      "label": "加价配送费",
      "width": "100",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cutDeliveryFee",
      "label": "配送费扣除",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.cutDeliveryFee ? scope.row.cutDeliveryFee : '—'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "extraAmount",
      "label": "搭伙费",
      "width": ""
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb315fee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/finance/schoolTotalBill.vue
// module id = 944
// module chunks = 0